module.exports = __webpack_public_path__ + "static/cicada_msg3-e6c1b9fc3c041fe4b62c8011eb6b7824.png";